<template>
  <div>
    <VTableRemote
      ref="tableRemoteRef"
      class="billingCustomTable"
      :items="allUsersDetails"
      hideDefaultFooter
      :headers="tableHeaders"
      :pagination="pagination"
      isCustomIcon
      :isSearchable="false"
      :loading="isFetching"
      :isInfinitScroll="true"
      @sendQueryParams="fetchQuery"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-start">
            {{ item.firsName }}
          </td>
          <td class="text-start">
            {{ item.lastname }}
          </td>
          <td class="text-start">
            {{ item.email }}
          </td>
          <td class="text-start">
            {{ item.phone }}
          </td>
          <td class="text-start">
            {{ $t(`roles.${item.role.key}`) }}
          </td>
          <td class="text-start">
            {{ dateFormat(item.memberDate) }}
          </td>
          <td class="text-start">
            {{ dateFormat(item.endDate) }}
          </td>
        </tr>
      </template>
      <template #withInfiniteScroll>
        <div v-intersect="endIntersect" />
      </template>
    </VTableRemote>
  </div>
</template>

<script>

import VTableRemote from '@/components/shared/content-views/VTableRemote.vue';
import perpage from '@/constants/pagination';

export default {
    name: 'UserDetails',
    components: { VTableRemote },
    props: {
        teamId: String,
        default: () => '',
    },
    data() {
        return {
            isFetching: false,
            allUsersDetails: [],
            pagination: {},
            queryParams: { perpage, page: 1 },
        };
    },
    computed: {
        tableHeaders() {
            return [
                {
                    text: this.$t('forms.labels.firstName'),
                    value: 'firstName',
                    width: 100,
                },
                {
                    text: this.$t('forms.labels.lastName'),
                    value: 'lastName',
                    width: 100,
                },
                {
                    text: this.$t('forms.labels.email'),
                    value: 'email',
                    width: 150,
                },
                {
                    text: this.$t('forms.labels.phoneNumber'),
                    value: 'phoneNumber',
                    width: 100,
                },
                {
                    text: this.$t('forms.labels.role'),
                    value: 'role',
                    width: 100,
                },
                {
                    text: this.$t('forms.labels.memberSince'),
                    value: 'dateMemberStart',
                    width: 100,
                },
                {
                    text: this.$t('contracts.endDate'),
                    value: 'dateMemberEnd',
                    width: 100,
                },
            ];
        },
    },
    async created() {
        await this.getAllUsersDetails();
    },
    methods: {
        async fetchQuery(queryParams) {
            this.queryParams = { ...this.queryParams, ...queryParams, page: 1 };
            this.pagination = {};
            this.allUsersDetails = [];
            await this.getAllUsersDetails();
        },
        async getAllUsersDetails() {
            this.isFetching = true;
            const cleanQueryParams = this.$utils.removeEmptyNullOrUndefined({ ...this.queryParams }, true);
            const { data } = await this.$rq.getCurrentBillingDetails('usersDetails', this.teamId, cleanQueryParams);
            this.allUsersDetails = [...this.allUsersDetails, ...data.usersDetails];
            this.pagination = data.pagination;
            this.isFetching = false;
        },
        dateFormat(date) {
            return this.$options.filters.formatDate(date, 'L');
        },
        async endIntersect(_, __, isIntersecting) {
            const condition = this.pagination.currentPage < this.pagination.totalPageCount;
            if (isIntersecting && condition && !this.isFetching) {
                this.queryParams.page = this.pagination.currentPage + 1;
                await this.getAllUsersDetails();
                const ref = this.$refs?.tableRemoteRef?.$refs?.tableRemote;
                if (ref?.onScroll) {
                    ref.onScroll();
                }
            }
        },
    },
};

</script>

<style lang="scss" scoped>
@import "@/assets/styles/pricingManagement.scss";
.billingCustomTable{
    ::v-deep table{
        padding:0 5px 0 0;
    }
    ::v-deep .blocHeader {
        height: 0;
    }
    ::v-deep .v-data-table__wrapper{
        height: 420px !important;
    }
    ::v-deep .custom-table.theme--light.v-data-table{
        height: 400px;
    }
}
</style>
